export default{
    products: [],
    product: null,
    pagesCount: 0,
    totalCountData: 0,
    currencies: []
}